import { connect } from 'react-redux';
import { fetchTag } from 'client/store/tag/thunks';
import { isLoading, getTag } from 'client/store/tag/selectors';
import { ServerFetchDataProps, SluggedPage, ConnectedComponent } from 'client/types/common';
import { State } from 'client/store';
import TagPage, { DispatchProps, StateProps } from './tag';

const mapStateToProps = (state: State): StateProps => ({
    data: getTag(state),
    isLoading: isLoading(state)
});

const mapDispatchToProps = { fetchTag };

const component = connect<StateProps, DispatchProps>(
    mapStateToProps,
    mapDispatchToProps
)(TagPage) as ConnectedComponent<typeof TagPage, StateProps & DispatchProps>;

component.serverFetchData = ({ dispatch, match }: ServerFetchDataProps<SluggedPage>) => {
    return dispatch(fetchTag(match.params.slug));
};

export default component;
